import React, {useEffect, useState} from "react";
import './TnC.css'
import Header from "../../../components/header/Header";
import Indicator from "../../common/components/Indicator";
import {Button, Form, message} from "antd";
import ModalContent from "../../../constant/ModalContent";
import {useNavigate} from "react-router-dom";
import {submitTnCRequest} from "../service/TnCService";
import type {TnCRequestModel} from "../models/TnCRequestModel";

export default function TnC() {
    const [isLoading, setIsLoading] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    const carrierPostData = window.location.search.match(/(?<=\?|&)carrierPostData=([^&]*)/)?.[1] ?? null;
    const sessionId = searchParams.get("sessionId") ?? null;
    const status = searchParams.get("status") ?? null;
    const mobileNumber = searchParams.get("msisdn") ?? null;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const tnCRequestModel: TnCRequestModel = {
                "request-id": values.requestId,
                carrierPostData: carrierPostData,
                imei: values.imei,
                "sip-username": values.sipUsername,
                status: status
            };
            console.log(tnCRequestModel);
            const response = await submitTnCRequest(tnCRequestModel);
            setIsLoading(false);
            console.log(response);
            if(response.status === "ACCEPT"){
                navigate("/vowifi/terms-and-condition/congrats");
            }
        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }
    useEffect(() => {
        localStorage.setItem('isLogin', false);
        console.log("isLogin", localStorage.getItem('isLogin'));
        localStorage.setItem("carrierPostData", carrierPostData);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("status", status);
        localStorage.setItem("msisdn", mobileNumber)

        // if (!carrierPostData || !sessionId || !status || !mobileNumber) {
        //     // Redirect to NotFoundPage if any data is null
        //     navigate('/not-found-page');
        // }

        console.log(carrierPostData);
        console.log(sessionId);
        console.log(status);
        console.log(mobileNumber);
    }, []);

    return (
        <div>
            <div style={{backgroundColor: "#E6E6E6", width: "100%"}}>
                <Header/>
            </div>
            {isLoading && <Indicator/>}
            <Form
                className="form"
                name="form"
                onFinish={handleSubmit}
            >
                <h1 className="para-title">
                    Terms and Conditions
                </h1>
                <div className="para">
                    <ul>
                        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                        <li>Donec euismod, nisl eget aliquam, nunc nisl aliquet nunc, vitae aliquam nisl nunc eu nunc.
                        </li>
                        <li>Donec euism nisl consequat aliquam, nunc nisl aliquet nunc, vitae aliquam nisl nunc eu
                            nunc.
                        </li>
                    </ul>
                </div>

                <Form.Item>
                    <Button
                        className="mainButton agreeButton"
                        type="primary"
                        htmlType="submit"
                        shape={"round"}
                        style={{backgroundColor: "#f13434"}}
                        // disabled={isLoading}
                    >
                        Agree all
                    </Button>
                    <Button
                        className="mainButton rejectButton"
                        type="primary"
                        htmlType="submit"
                        shape={"round"}
                        style={{backgroundColor: "#f13434"}}
                        disabled={isLoading}
                    >
                        Reject
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}